import apiConfig from "constants/apiConfig";
import { InfluencerInsights, Posts } from "types/influencer";
import axiosClient from "utils/axiosClient";

export const fetchInfluencerInsights = async (agencyId: string, influencerId: string): Promise<InfluencerInsights> => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_INSIGHTS.url.replace('<agencyId>', agencyId)
        .replace('<influencerId>', influencerId)
    )
    return response.data;
}

export const fetchPost = async (agencyId: string, influencerId: string, postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_POST.url.replace('<agencyId>', agencyId)
        .replace('<influencerId>', influencerId)
        .replace('<postId>', postId)
    )
    return response.data.post;
}

export const fetchBasicPost = async (agencyId: string, postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_BASIC_POST.url.replace('<agencyId>', agencyId)
        .replace('<postId>', postId)
    )
    return response.data.post;
}

export const fetchBasicSocialPost = async (agencyId: string, postId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_BASIC_SOCIAL_POST.url.replace('<agencyId>', agencyId)
        .replace('<postId>', postId)
    )
    return response.data.social_post;
}

export const fetchMedia = async (agencyId: string, influencerId: string, payload: any = {}) : Promise<any> => {
    const response = await axiosClient.get(apiConfig.FETCH_INFLUENCER_MEDIA.url.replace('<agencyId>', agencyId)
    .replace('<influencerId>', influencerId), {params: {...payload, limit: 15, sort: 'like_count' }});

    return response.data;
}

export const fetchSocialMedia = async (agencyId: string, socialAccountId: string, payload: any = {}) : Promise<any> => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POSTS.url.replace('<agencyId>', agencyId)
    .replace('<socialAccountId>', socialAccountId), {params: { ...payload, limit: payload.limit ?? 15 }});

    return response.data;
}

export const fetchSocialPost = async (agencyId: string, socialAccountId: string, socialPostId: string) => {
    const response = await axiosClient.get(apiConfig.FETCH_SOCIAL_POST.url.replace('<agencyId>', agencyId)
        .replace('<socialAccountId>', socialAccountId)
        .replace('<socialPostId>', socialPostId)
    )
    return response.data.social_post;
}